var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClickLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.196 4.619c-.32 0-.577.26-.577.578v9.813a.577.577 0 0 0 1.036.347l1.803-2.01 2 4.618c.183.426.682.618 1.107.426.417-.189.6-.68.411-1.097l-2.062-4.57 3.208-.023a.576.576 0 0 0 .364-1.026L8.648 4.838a.57.57 0 0 0-.452-.219"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.767 3.009A7.12 7.12 0 0 0 3.01 10.47c.182 3.684 3.25 6.606 6.837 6.76.552.023 1.045.415 1.1.965s-.345 1.046-.897 1.04c-4.713-.052-8.8-3.853-9.038-8.666a9.119 9.119 0 1 1 15.5 6.054c-.395.387-1.028.309-1.37-.125-.342-.433-.261-1.058.12-1.457A7.119 7.119 0 0 0 9.767 3.01",
  clipRule: "evenodd"
})));
export default SvgIconClickLink;